import { Globe } from 'lucide-react';
import { useI18n } from '@/lib/i18n/context';

export function LanguageSwitcher() {
  const { locale, toggleLocale } = useI18n();
  const isAr = locale === 'ar';

  return (
    <button
      type="button"
      onClick={toggleLocale}
      className="flex min-h-[44px] min-w-[44px] items-center gap-1.5 rounded-full border border-white/40 bg-white/10 px-3 text-sm font-semibold text-white transition-colors hover:bg-white/20 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60"
      aria-label={isAr ? 'Switch language to English' : 'تغيير اللغة إلى العربية'}
    >
      <Globe className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>{isAr ? 'EN' : 'العربية'}</span>
    </button>
  );
}
